import React, { Component } from 'react';
import { connect } from 'react-redux'
import { getSlider, clearSlider, getSessions } from './actions';
import Spiner from '../helpers/Spiner/Spiner';
import './style.scss'
import Sliders from './components/Sliders';
import Slide from './components/Slide';

class Slider extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loaded: false,
      session_id: 0,
      imgs_loaded: true,
    }
  }
  
  async componentDidMount(){
    console.log("🚀 ~ Slider ~ componentDidMount ~ this.props.match:", this.props.match)

    await this.props.getSlider(this.props.match.params.id, 0);
    this.setState({loaded: true})
  }

  componentWillUnmount(){
    this.props.clearSlider()
  }

  loadFileSpiner = (status) => {
    this.setState({imgs_loaded: status})
  }

  render() {
    const {loaded, imgs_loaded} = this.state;
    const {data_loaded, loaded_imgs} = this.props;
    console.log("Slider -> render -> data_loaded", data_loaded)
    if(!loaded) {
      return <Spiner />
    }
    return (
      <div className="qbm-content Slider row">
        {(!data_loaded || !imgs_loaded || !loaded_imgs) && <div style={{display: 'flex', position: 'absolute', zIndex: 999, width: '100%', height: 'calc(100% - 50px)', background: 'rgba(255, 255, 255, 0.4)'}}>
          <Spiner />
        </div>}
        <Sliders loadFileSpiner={this.loadFileSpiner}/>
        <Slide />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  data_loaded: state.slider.loaded,
  loaded_imgs: state.slider.loaded_imgs,
})

const mapDispatchToProps = {
  getSlider,
  clearSlider,
  getSessions,
}

export default connect(mapStateToProps, mapDispatchToProps)(Slider)



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/Slider/Slider.jsx